import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { GCMService } from '../../shared/services/gcm.service';

@Component({
  standalone: false,
  selector: 'app-scr-edit-dialog',
  templateUrl: './scr-edit-dialog.component.html',
  styleUrls: ['./scr-edit-dialog.component.css']
})

export class ScrEditDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  invalidInput: boolean = false;
  invalidInput1: boolean = false;
  invalidInput2: boolean = false;
  invalidInput3: boolean = false;
  invalidInput4: boolean = false;
  invalidInput5: boolean = false;
  invalidInput6: boolean = false;
  invalidInput7: boolean = false;
  invalidInput8: boolean = false;
  invalidInput9: boolean = false;
  errorMessage: string = '';
  errorMessage1: string = '';
  errorMessage2: string = '';
  errorMessage3: string = '';
  errorMessage4: string = '';
  errorMessage5: string = '';
  errorMessage6: string = '';
  errorMessage7: string = '';
  errorMessage8: string = '';
  errorMessage9: string = '';
  formGroup1: any;
  user: any = [];
  roles: any = [];

  constructor(
    public dialogRef: MatDialogRef<ScrEditDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService,
    private GCMService: GCMService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.formGroup1 = this._formBuilder.group({
      structureCtrl: [{ value: this.local_data.element.structure, disabled: true }],
      codeNameCtrl: [{ value: this.local_data.element.cecoCodeName, disabled: true }],
      gcm0Ctrl: [this.local_data.element.gcms[0], Validators.required],
      gcm1Ctrl: [this.local_data.element.gcms[1], Validators.required],
      gcm2Ctrl: [this.local_data.element.gcms[2], Validators.required],
      gcm3Ctrl: [this.local_data.element.gcms[3], Validators.required],
      gcm4Ctrl: [this.local_data.element.gcms[4], Validators.required],
      gcm5Ctrl: [this.local_data.element.gcms[5], Validators.required],
      gcm6Ctrl: [this.local_data.element.gcms[6], Validators.required],
      gcm7Ctrl: [this.local_data.element.gcms[7], Validators.required],
      gcm8Ctrl: [this.local_data.element.gcms[8], Validators.required],
      gcm9Ctrl: [this.local_data.element.gcms[9], Validators.required],
      costCenterCtrl: [{ value: this.local_data.element.costCenter, disabled: true }],
    });


  }

  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;

    if (!formGroup.gcm0Ctrl || Number(formGroup.gcm0Ctrl) < 0) {
      this.invalidInput = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm1Ctrl || formGroup.gcm1Ctrl < 0) {
      this.invalidInput1 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm2Ctrl || formGroup.gcm2Ctrl < 0) {
      this.invalidInput2 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm3Ctrl || formGroup.gcm3Ctrl < 0) {
      this.invalidInput3 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm4Ctrl || formGroup.gcm4Ctrl < 0) {
      this.invalidInput4 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm5Ctrl || formGroup.gcm5Ctrl < 0) {
      this.invalidInput5 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm6Ctrl || formGroup.gcm6Ctrl < 0) {
      this.invalidInput6 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm7Ctrl || formGroup.gcm7Ctrl < 0) {
      this.invalidInput7 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm8Ctrl || formGroup.gcm8Ctrl < 0) {
      this.invalidInput8 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else if (!formGroup.gcm9Ctrl || formGroup.gcm9Ctrl < 0) {
      this.invalidInput9 = true;
      this.errorMessage = this.variables.errorOnValues;
      valid = false;
    }
    else {
      this.invalidInput = false;
    }

    //Pass data
    if (valid) {
      const ceco: any = {
        id: this.local_data.element.id,
        practice: this.local_data.element.practice,
        subPractice: this.local_data.element.subPractice,
        codeName: this.local_data.element.cecoCodeName,
        costCenter: this.local_data.element.costCenter,
        gcms: [formGroup.gcm0Ctrl, formGroup.gcm1Ctrl, formGroup.gcm2Ctrl, formGroup.gcm3Ctrl, formGroup.gcm4Ctrl, formGroup.gcm5Ctrl, formGroup.gcm6Ctrl, formGroup.gcm7Ctrl, formGroup.gcm8Ctrl, formGroup.gcm9Ctrl]
      }

      this.GCMService.updateCECO(ceco.id, ceco).subscribe((response: any) => {
        if (response) {
          this.dialogRef.close({ data: ceco });
        }
      })

    }
  }

}
